import React, { useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import EnhancedSearchBar from './QueryComponent/EnhancedSearchBar';
import DatasetCard from './QueryComponent/DataSetCard';
import { addTransactionDetails, datasetCard } from '../../redux/Slices/datasetSlice';
import { searchDataset } from '../../redux/Thunks/datasetThunks';
import { makeApiRequest } from '../common/API_request';
import { authTokens } from '../../redux/Selectors/selectors';
import { useNavigate } from 'react-router-dom';




const MarketPlaceQuery = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [searched, setSearched] = useState(false);
  const searchResults = useSelector(datasetCard)
  const token = useSelector(authTokens)

  const handleSearch = async (query) => {
    setSearched(true)
    await dispatch(searchDataset(query)).unwrap()
    setSearched(false)
  };

  const purchaseData = async () => {
    const dataset_access_id = searchResults?.dataset_access_id
    const price = searchResults?.price

    const url = `${process.env.REACT_APP_SERVER_URL}/api/marketplace/create-payment-intent/`
    const headers = {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token?.accessToken}`
    }
    const body = {
      dataset_access_id,
      price
    }
    const response = await makeApiRequest(url,"POST",headers,body)

    if(response){
      dispatch(addTransactionDetails({
          clientSecretKey: response?.clientSecret,
          price: response?.price,
          dataset_access_id
        })
      )
      navigate("/profile/dataset/payments")
    }


  }

  return (
    <div className="">
      <main className="container mx-auto mt-4 px-2.5 py-4 sm:p-4">
        <h1 className="font-bold mb-4 text-center">What data are you looking for?</h1>
        <EnhancedSearchBar
        onSearch={handleSearch}
        clicked={searched}
         />
        {searchResults &&
          <div className="mt-8 px-2.5 sm:px-4 relative h-screen
         overflow-y-scroll scroll-bar-in-dark">
            <p className='w-full bg-[#211919] sm:bg-[#5B5B5B]
        text-2xl sm:text-4xl text-center
        italic pb-4'>Search Results</p>

            <div>
              <DatasetCard
                {...searchResults?.data}
                actionName="Purchase"
                notPurchased={true}
                onPurchase={purchaseData}
              />
            </div>
          </div>
        }
      </main>
    </div>
  );
};

export default MarketPlaceQuery;
